export default __webpack_public_path__ + "static/Ahmed_Munir-d48bbcdff1c2c1cb17c5773165731dac.png";